// eslint-disable-next-line import-x/no-extraneous-dependencies
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../tailwind.config';

/* Resolves tailwind config */

const styleConfig = resolveConfig(tailwindConfig);

export default styleConfig;
